<template src="./template.html"></template>

<script>
import olMapMixin from '@/mixin/olMapMixin'
import olMapDragBoxMixin from '@/mixin/olMapDragBoxMixin'
import ExtremeMapRecLayerManager from '@/lib/ExtremeMapRecLayerManager'
import ShutokouKilopostLayerManager from './ShutokouKilopostLayerManager'

export default {
  name: 'extreme-map2',
  props: {
    stream: {
      type: Object,
    }
  },
  data() {
    return {
      currentMapType: '',
      currentRecType: 'stopped',

      mapTypeInfo: {
        gmap: {
          dispName: 'Street',
          getLayerFuncName: 'getGoogleMapLayer',
        },
        bing: {
          dispName: 'Aerial',
          getLayerFuncName: 'getBingMapLayer',
        },
        toggleOrderArr: ['gmap', 'bing'],
      },

      selectedRoadNames: [],
      roadInfos: [],
      roadInfoMap: {},
      kpGroups: {},

      showKpsDirectionUp: true,
      showKpsDirectionDown: true,
      showKpsDirectionSouth: true,
      showKpsDirectionNorth: true,
      showKpsDirectionWest: true,
      showKpsDirectionEast: true,
      showKpsDirectionCounterclockwise: true,
      showKpsDirectionClockwise: true,

      showKpsPlaceMainLine: true,
      showKpsPlaceJct: true,
      showKpsPlaceEntrance: true,
      showKpsPlaceExit: true,

      showKpsVisibilityVisible: true,
      showKpsVisibilityHidden: true,

      kpTextShowType: 1,
      kpAngleShowType: 0,

      recLayerMgr: null,

      onResizeFunc: null,
    }
  },
  computed: {
    componentId() {
      return `extreme-map-${this._uid}`
    },
    olMapId() {
      return `ol-map-${this._uid}`
    },
    olPopupId() {
      return `ol-popup-${this._uid}`
    },
    olPopupContentId() {
      return `ol-popup-content-${this._uid}`
    },
    olPopupCloserId() {
      return `ol-popup-closer-${this._uid}`
    },
    currentMapTypeDisp() {
      if (!this.mapTypeInfo[this.currentMapType]) { return '' }
      return this.mapTypeInfo[this.currentMapType].dispName
    },
    currentRecTypeDisp() {
      let ret = ''
      if (this.currentRecType === 'started') {
        ret = '終'
      } else if (this.currentRecType === 'stopped') {
        ret = '始'
      }
      return ret
    },
  },
  mixins: [olMapMixin, olMapDragBoxMixin],
  mounted() {
    this.initMapManager({
      element: `ol-map-${this._uid}`,
      center: this.convCoord({
        lat: 35.679100,
        lon: 139.756932,
      }),
      maxZoom: 25,
      minZoom: 4,
      zoom: 10,
      enablePan: true,
      enableZoomButton: true,
      enableMouseWheelZoom: true,
      enableDoubleClickZoom: true,
      enableScaleLine: true,
    })

    {
      const layer = this.getGoogleMapLayer()
      this.currentMapType = layer.name
      this.addLayer(layer)
    }

    {
      const { layer, interaction } = this.getDragBoxDrawLayer()
      this.addLayer(layer)
      this.addMapInteraction(interaction)
    }

    this.addDebugClickEvent()
    this.setListeners()

    this.initResizeFunc()
  },
  destroyed() {
    window.removeEventListener('resize', this.onResizeFunc)
  },
  methods: {
    setListeners() {
    },
    initResizeFunc() {
      // resize map on window resize
      this.onResizeFunc = () => {
        const h = window.innerHeight - 126
        const elem = document.getElementById(this.olMapId)
        elem.style.height = `${h}px`
        this.updateMapSize()
      }
      this.onResizeFunc()
      window.addEventListener('resize', this.onResizeFunc)
    },
    startRec() {
      this.recLayerMgr = new ExtremeMapRecLayerManager()
      const { layer, layerInfo } = this.recLayerMgr.prepareLayer()
      this.addLayer(layer, {
        interaction: {
          click: layerInfo.onClick,
        },
      })
      this.currentRecType = 'started'
    },
    stopRec() {
      this.removeLayer('rec')
      this.currentRecType = 'stopped'
      this.recLayerMgr.dumpPoints()
      this.recLayerMgr = null
    },
    startStopRec() {
      if (this.currentRecType === 'started') {
        this.stopRec()
      } else {
        this.startRec()
      }
    },
    getNextMapType() {
      const arr = this.mapTypeInfo.toggleOrderArr
      const idx = arr.indexOf(this.currentMapType)
      const nextIdx = (idx + 1) % arr.length
      return arr[nextIdx]
    },
    getMapLayer(mapType) {
      const funcName = this.mapTypeInfo[mapType].getLayerFuncName
      return this[funcName]()
    },
    changeMapType() {
      const nextMapType = this.getNextMapType()
      this.addLayer(this.getMapLayer(nextMapType), { insertAt: 0 })
      this.removeLayer(this.currentMapType)
      this.currentMapType = nextMapType
    },
    moveMapTo(extent) {
      this.fitToExtent(extent, {
        maxZoom: 20,
        duration: 500,
      })
    },
    onChangeSelectedRoadNames() {
      this.removeKilopostsLayer()
      const { layerInfo } = this.refreshKilopostsLayer_()
      this.moveMapTo(layerInfo.extent)
    },
    setFocusAreaFromDragBox() {
      const geom = this.getDragResultRectGeometry()
      if (!geom) { return }
      this.moveMapTo(geom.getExtent())
    },
    roadNameToSortOrder(roadName) {
      let m = roadName.match(/^高速(\d+)号/)
      if (m) { return parseInt(m[1]) }
      m = roadName.match(/^高速(中央|八重洲|都心)/)
      if (m) { return 100 }
      m = roadName.match(/^高速(川口|埼玉)/)
      if (m) { return 200 }
      m = roadName.match(/^高速神奈川/)
      if (m) { return 300 }
      m = roadName.match(/^高速湾岸/)
      if (m) { return 400 }
      return 9999
    },
    getRoadInfos(kps) {
      const tmpMap = {}
      const retMap = {}
      kps.forEach(kp => {
        if (!retMap[kp.road_name_disp]) {
          retMap[kp.road_name_disp] = []
          tmpMap[kp.road_name_disp] = {}
        }
        if (!tmpMap[kp.road_name_disp][kp.road_name]) {
          tmpMap[kp.road_name_disp][kp.road_name] = 1
          retMap[kp.road_name_disp].push(kp.road_name)
        }
      })
      const retArr = Object.entries(retMap).reduce((acc, [k, v]) => {
        acc.push({ name: k, roads: v })
        return acc
      }, []).sort((a, b) => {
        const v1 = this.roadNameToSortOrder(a.name)
        const v2 = this.roadNameToSortOrder(b.name)
        return v1 < v2 ? -1 : v1 > v2 ? 1 : 0
      })
      return { arr: retArr, map: retMap }
    },
    refreshKilopostsLayer_() {
      const selectedKpGroups = []
      for (const roadNameDisp of this.selectedRoadNames) {
        this.roadInfoMap[roadNameDisp].forEach(roadName => {
          const selectedDirections = []
          const selectedPlaces = []
          if (this.showKpsDirectionUp) { selectedDirections.push('上') }
          if (this.showKpsDirectionDown) { selectedDirections.push('下') }
          if (this.showKpsDirectionSouth) { selectedDirections.push('南') }
          if (this.showKpsDirectionNorth) { selectedDirections.push('北') }
          if (this.showKpsDirectionWest) { selectedDirections.push('西') }
          if (this.showKpsDirectionEast) { selectedDirections.push('東') }
          if (this.showKpsDirectionCounterclockwise) { selectedDirections.push('内') }
          if (this.showKpsDirectionClockwise) { selectedDirections.push('外') }

          if (this.showKpsPlaceMainLine) { selectedPlaces.push('main_line') }
          if (this.showKpsPlaceJct) { selectedPlaces.push('JCT') }
          if (this.showKpsPlaceEntrance) { selectedPlaces.push('入口') }
          if (this.showKpsPlaceExit) { selectedPlaces.push('出口') }

          selectedDirections.forEach(direction => {
            const name = `${roadName}#${direction}`
            const origObj = this.kpGroups[name]
            if (!origObj) { return }
            const obj = {}
            Object.keys(origObj).forEach(k => {
              selectedPlaces.forEach(placeName => {
                if (k.indexOf(placeName) === -1) { return }

                if (this.showKpsVisibilityVisible && this.showKpsVisibilityHidden) {
                  obj[k] = origObj[k]
                } else if (this.showKpsVisibilityVisible) {
                  obj[k] = origObj[k].filter(e => !e.is_hidden)
                } else if (this.showKpsVisibilityHidden) {
                  obj[k] = origObj[k].filter(e => e.is_hidden)
                }
              })
            })
            selectedKpGroups.push({ name, obj })
          })
        })
      }
      const opts = {
        kpTextShowType: this.kpTextShowType,
        kpAngleShowType: this.kpAngleShowType,
      }

      const mgr = new ShutokouKilopostLayerManager()
      const { layer, layerInfo } = mgr.prepareLayer(selectedKpGroups, opts)
      layer.setZIndex(1000)
      this.addLayer(layer)
      return { layer, layerInfo }
    },
    showKilopostsLayer(kps) {
      const roadInfos = this.getRoadInfos(kps)
      this.roadInfos = roadInfos.arr
      this.roadInfoMap = roadInfos.map

      const selectedRoadNames = []
      for (const { name } of this.roadInfos) {
        selectedRoadNames.push(name)
      }
      this.selectedRoadNames = selectedRoadNames

      const kpGroups = {}
      kps.forEach(kp => {
        const k = kp.road_name + '#' + kp.direction
        if (!kpGroups[k]) {
          kpGroups[k] = {}
        }
        const placeName = kp.place_name || 'main_line'
        if (!kpGroups[k][placeName]) {
          kpGroups[k][placeName] = []
        }
        kpGroups[k][placeName].push(kp)
      })

      for (const ent1 of Object.entries(kpGroups)) {
        for (const ent2 of Object.entries(ent1[1])) {
          const arr = ent2[1]
          arr.sort((a, b) => {
            return a.kp_calc < b.kp_calc ? -1 : 1
          })
        }
      }
      this.kpGroups = kpGroups

      const { layerInfo } = this.refreshKilopostsLayer_()
      this.moveMapTo(layerInfo.extent)
    },
    removeKilopostsLayer() {
      const mgr = new ShutokouKilopostLayerManager()
      this.removeLayer(mgr.getLayerName())
    },
    onShowKpsChange() {
      this.refreshKilopostsLayer_()
    }
  }
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
